import Repository from './Repository'

const action = 'no-paper'

export default {
  sendAct(data) {
    return Repository.post(action + '/send-akt', data)
  },
  checkNopaper(data) {
    return Repository.post(action + '/check-contragent', data)
  },
}
